import {
  Autocomplete,
  Button,
  Card,
  CardHeader,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo } from "react";
import { TbReport } from "react-icons/tb";
import { BsSearch } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { setSelectedReport } from "../../../../../app/slices/jomla/reportsSlice";

const JReportsHeader = () => {
  const dispatch = useDispatch();

  const reportTypes = useSelector((state) => state.jReports.reportTypes);
  const userPermissions = useSelector(
    (state) => state.user.userInfo.permissions
  );
  const userRoles = useSelector((state) => state.user.userInfo.user_roles);

  // Filter report types based on user permissions or roles
  const allowedReportTypes = useMemo(() => {
    // Check if user has one of the privileged roles first
    const privilegedRoles = [
      "super_admin",
      "team_leader",
      "admin",
      "wholesale",
    ];
    const hasPrivilegedRole =
      userRoles && userRoles.some((role) => privilegedRoles.includes(role));

    const userRolesList = Array.isArray(userRoles) ? userRoles : [];
    const userPermissionNames = Array.isArray(userPermissions)
      ? userPermissions.map((permission) => permission.name)
      : [];

    // Role-restricted reports: allow if user has one of the required roles OR the specific permission
    return reportTypes.filter((reportType) => {
      const hasRequiredPermission = reportType.permission
        ? userPermissionNames.includes(reportType.permission)
        : false;

      if (Array.isArray(reportType.roles) && reportType.roles.length > 0) {
        const hasRequiredRole = userRolesList.some((role) =>
          reportType.roles.includes(role)
        );
        // For reports like "الارباح": show if super_admin OR has j_revenue_report
        return hasRequiredRole || hasRequiredPermission;
      }

      // If no explicit role restriction:
      // - privileged roles can see it
      if (hasPrivilegedRole) return true;

      // - otherwise require matching permission
      return hasRequiredPermission;
    });
  }, [reportTypes, userPermissions, userRoles]);

  useEffect(() => {
    const selectedReport = reportTypes.find((report) => report.isSelected);
    if (selectedReport) {
      // Ensure selected report is allowed; otherwise clear selection
      const isAllowed = allowedReportTypes.some(
        (r) => r.name === selectedReport.name
      );
      setReportType(isAllowed ? selectedReport.name : null);
    } else {
      setReportType(null);
    }
  }, [reportTypes, allowedReportTypes]);

  const [reportType, setReportType] = useState(null);

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            التقارير
          </Typography>
        }
        avatar={<TbReport size={20} />}
        action={
          <Stack direction="row" spacing={2}>
            {allowedReportTypes.length > 0 ? (
              <>
                <Autocomplete
                  sx={{ width: "30vh" }}
                  options={allowedReportTypes}
                  getOptionLabel={(option) => option.type}
                  fullWidth
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      fullWidth
                      required
                      {...params}
                      label="اختر نوع التقرير"
                    />
                  )}
                  onChange={(event, value) => {
                    setReportType(value ? value.name : null);
                  }}
                  value={
                    allowedReportTypes.filter((x) => x.name === reportType)[0]
                      ? allowedReportTypes.filter(
                          (x) => x.name === reportType
                        )[0]
                      : null
                  }
                />
                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  startIcon={<BsSearch />}
                  onClick={() => dispatch(setSelectedReport(reportType))}
                  disabled={!reportType}
                >
                  بحث
                </Button>
              </>
            ) : (
              <Typography variant="body2" color="text.secondary">
                لا توجد صلاحيات لعرض التقارير
              </Typography>
            )}
          </Stack>
        }
      />
    </Card>
  );
};

export default JReportsHeader;
